import {
  Button,
  Card,
  Classes,
  FormGroup,
  Icon,
  InputGroup,
  Intent,
  Tag,
  TagInput,
  Text,
  Colors,
} from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { Tooltip2 } from '@blueprintjs/popover2'
import variableOrQuestionToString from '../../utils/variableOrQuestionToString'

export default function InputSelectionPanel({
  query,
  queryChange,
  filteredOptions,
  numericVariables,
  filteredSelection,
  selected,
  set,
  segSizes,
  reset,
}) {
  const validInputs = selected.length && selected.length >= segSizes[1]

  return (
    <Card id="input-select-container" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '15px' }} elevation={1}>
      <div style={{ flex: '1', display: 'flex', flexDirection: 'column', overflow: 'hidden', marginBottom: '15px', minHeight: 0 }}>
        <FormGroup
          label={
            <span style={{ fontSize: 13 }}>
              <Icon
                icon={IconNames.PROPERTIES}
                size={12}
                style={{ marginRight: '5px' }}
              />
              Inputs
            </span>
          }
          labelFor="inputs"
          style={{ height: '100%', display: 'flex', flexDirection: 'column', margin: 0 }}
        >
          <InputGroup
            leftIcon="filter"
            placeholder="Filter input list"
            rightElement={
              <>
                {filteredOptions && filteredOptions.length !== numericVariables.length ? (
                  <Tag minimal>
                    {filteredOptions.length}/{numericVariables.length}
                  </Tag>
                ) : null}
                <Tooltip2
                  content={query ? 'Clear filter' : null}
                  minimal
                  placement="right"
                >
                  <Button
                    minimal
                    title="Clear filter"
                    icon="cross"
                    disabled={!query}
                    onClick={() => queryChange('')}
                  />
                </Tooltip2>
              </>
            }
            style={{ marginBottom: 10, flexShrink: 0 }}
            value={query}
            onChange={e => queryChange(e.target.value)}
          />
          <select
            className={Classes.INPUT}
            id="inputs"
            multiple
            style={{ width: '100%', flex: '1', overflow: 'auto', minHeight: 0 }}
          value={filteredSelection?.map(o => o.id) || []}
          onChange={e => {
            const selectedIds = [...e.target.selectedOptions].map(o => o.value)

            const itemsOutsideFilter = (selected || []).filter(
              item => !(filteredOptions || []).find(o => o.id === item.id)
            )

            const newlySelectedInFilter = selectedIds
              .filter(id => !(selected || []).some(item => `${item.id}` === `${id}`))
              .map(id => numericVariables.find(v => `${v.id}` === `${id}`))
              .filter(Boolean)

            const alreadySelectedInFilter = (selected || []).filter(item =>
              selectedIds.includes(`${item.id}`) &&
              (filteredOptions || []).find(o => o.id === item.id)
            )

            set([...itemsOutsideFilter, ...alreadySelectedInFilter, ...newlySelectedInFilter])
          }}
        >
          {(filteredOptions || []).map(v => {
            const text = variableOrQuestionToString(v, null)
            return (
              <option value={v.id} key={v.id}>
                {text}
              </option>
            )
          })}
        </select>
      </FormGroup>
      </div>
      <FormGroup
        helperText={
          !validInputs ? (
            <Text style={{ color: Colors.RED3, fontWeight: 500 }}>
              Select at least {segSizes[1]} inputs
            </Text>
          ) : null
        }
        label="Inputs Selected"
        labelInfo="(above)"
        labelFor="inputs-selected"
        style={{ flexShrink: 0 }}
      >
        <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
          <TagInput
            id="inputs-selected"
            leftIcon={IconNames.PROPERTIES}
            values={[]}
            onRemove={(_, index) =>
              set([
                ...selected.slice(0, index),
                ...selected.slice(index + 1),
              ])
            }
            inputProps={{
              disabled: true,
              value: '',
              onFocus: e => e.target.blur(),
            }}
            disabled={selected.length === 0}
            tagProps={{ minimal: true }}
            intent={segSizes[1] > selected.length ? Intent.DANGER : null}
            placeholder={selected.length ? '' : 'Select inputs above'}
            rightElement={
              <div style={{ padding: '5px 6px' }}>
                <Tag
                  minimal={selected.length === 0}
                  icon={<Icon icon={IconNames.PROPERTY} size="10" />}
                  intent={
                    selected.length
                      ? segSizes[1] > selected.length
                        ? Intent.DANGER
                        : Intent.PRIMARY
                      : Intent.NONE
                  }
                  onRemove={() => reset()}
                >
                  {selected.length} input{selected.length !== 1 ? 's' : ''}
                </Tag>
              </div>
            }
          >
            {selected.map((v, i) => (
              <Tooltip2
                key={v.id}
                popoverClassName="input-tooltip"
                className="input-tooltip"
                content={
                  v?.label ? (
                    <span style={{ fontSize: 12 }}>{v.label}</span>
                  ) : null
                }
                minimal
              >
                <Tag
                  key={v.id}
                  minimal
                  onRemove={() =>
                    set([
                      ...selected.slice(0, i),
                      ...selected.slice(i + 1),
                    ])
                  }
                >
                  {v.name}
                </Tag>
              </Tooltip2>
            ))}
          </TagInput>
        </div>
      </FormGroup>
    </Card>
  )
}
